export default __webpack_public_path__ + "static/media/arrow-blue.e4213595.svg";